var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ipfs-info"},[_c('p',[_vm._v(" "+_vm._s(_vm.status)),_c('br'),_vm._v(" ID: "+_vm._s(_vm.id)),_c('br'),_vm._v(" Agent version: "+_vm._s(_vm.agentVersion)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }